<template>
  <model-form
    ref="modelForm"
    :model="employeeJobType"
    modal-type="modal"
    title="Job Type"
  >
    <div>
      <div class="row q-col-gutter-md q-mb-md">
        <q-input
          v-model="employeeJobType.name"
          class="col-12"
          label="Name"
          :rules="[
            val => !!val || 'Field is required',
          ]"
        />
        <q-input
          v-model.number="employeeJobType.hourlyRate"
          class="col-6"
          label="Default Hourly Rate"
          type="number"
          :prefix="currentCircuit.localeCurrencySymbol"
          step="0.01"
          :rules="[val => !!val || val === 0 || 'Field is required']"
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'EmployeeJobTypeForm',
  components: {
    ModelForm
  },
  models: {
    employeeJobType: 'default'
  },
  configuration: ['currentCircuit'],
  methods: {

  }
}

</script>
